import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PriceLine } from '../../../model/price-line';

@Component({
  selector: 'price-line-input',
  templateUrl: './price-line-input.component.html',
  styleUrls: ['./price-line-input.component.scss']
})
export class PriceLineInputComponent implements OnInit {
  @Input()
  public priceLine: PriceLine;
  @Input()
  alignWithBoardPrices = false;
  @Input()
  disablePriceEdit = false;

  @Output()
  public output = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (this.priceLine == null) {
      this.priceLine = new PriceLine();
    }
    if (this.priceLine.placementLine) {
      this.priceLine.text = 'Productprijs';
    }
  }

  lineChanged($event) {
    this.output.emit(this.priceLine);
  }

  priceChanged(value) {
    this.setPrice(this.priceLine, value);
    this.output.emit(this.priceLine);
  }

  getPriceNumber(): number {
    if (this.priceLine != null) {
      return Number(this.priceLine.price.replace(/,/, '.'));
    } else {
      return 0;
    }
  }

  setPrice(line: PriceLine, price: number): void {
    if (price != null) {
      this.priceLine.price = price.toString();
    }
  }
}
